/**
 * Sdílená inicializace swiperu nahraných videí (komponenta .VideoSwiper).
 * Funguje pro libovolný počet instancí na stránce; navigaci/paginaci hledá
 * scopovaně uvnitř vlastního .VideoSwiper wrapperu, takže nekoliduje s jinými swipery.
 */
document.addEventListener("DOMContentLoaded", function () {
    const swipers = document.querySelectorAll("[data-video-swiper]");
    if (!swipers.length) return;

    swipers.forEach((el) => {
        const root = el.closest(".VideoSwiper") || el.parentElement;
        // primárně vlastní třídy komponenty; fallback .swiper-button-* drží PHP overridy
        // se starším markupem (easy-v5 textová navigace .swiper-controls)
        const prevEl = root ? root.querySelector(".VideoSwiper-button--prev, .swiper-button-prev") : null;
        const nextEl = root ? root.querySelector(".VideoSwiper-button--next, .swiper-button-next") : null;
        const paginationEl = root ? root.querySelector(".VideoSwiper-pagination, .swiper-pagination") : null;

        // spolehlivě skryj ovládání u jediného videa (nezávisle na podpoře :has())
        if (root && el.querySelectorAll(".swiper-slide").length <= 1) {
            root.classList.add("VideoSwiper--single");
        }

        const instance = new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 20,
            watchOverflow: true,
            navigation: (prevEl && nextEl) ? { prevEl, nextEl } : false,
            pagination: paginationEl ? { el: paginationEl, type: "bullets", clickable: true } : false,
            on: {
                slideChange: function () {
                    // Chrome nepřepočítá nativní ovládání <video> ve slidu mimo viewport,
                    // když se swiper po initu přeměří (RO update) — příchozí slide by měl
                    // zatuhlý poster/progress bar až do hoveru. Reset controls vynutí layout.
                    const entering = this.slides[this.activeIndex];
                    const enteringVideo = entering ? entering.querySelector("video") : null;
                    if (enteringVideo && enteringVideo.controls) {
                        enteringVideo.controls = false;
                        void enteringVideo.offsetWidth; // vynucený reflow — synchronně, bez závislosti na rAF/paintu
                        enteringVideo.controls = true;
                    }

                    const leaving = this.slides[this.previousIndex];
                    if (!leaving) return;
                    const video = leaving.querySelector("video");
                    if (video) video.pause();
                    const iframe = leaving.querySelector("iframe");
                    if (iframe && iframe.contentWindow) {
                        // pauzni embed bez reloadu → po návratu pokračuje od stejného místa (jako <video>)
                        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*"); // YouTube
                        iframe.contentWindow.postMessage('{"method":"pause"}', "*"); // Vimeo
                    }
                },
            },
        });

        // Video bývá skryté pod tabem — swiper inicializovaný v display:none má nulové
        // rozměry, po zobrazení (0 → reálná šířka) je nutný přepočet. ResizeObserver na
        // samotném elementu pokryje i změny velikosti okna/layoutu.
        new ResizeObserver(() => {
            if (el.offsetParent !== null) instance.update();
        }).observe(el);
    });
});
